import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from '../../core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-update-phone-number-dialog',
  templateUrl: './update-phone-number-dialog.component.html',
  styleUrls: ['./update-phone-number-dialog.component.scss']
})
export class UpdatePhoneNumberDialogComponent implements OnInit {
  phoneForm: FormGroup;
  userID: string;
  submitted = false;

  constructor(private fb: FormBuilder, private commonService: CommonService, private toastr: ToastrService, private router: Router,
    public dialogRef: MatDialogRef<UpdatePhoneNumberDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.buildPhoneForm();
  }

  ngOnInit() {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      this.router.navigate(["login"]);
    } else {
      this.userID = userId;
    }
  }

  buildPhoneForm() {
    this.phoneForm = this.fb.group({
      phoneNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]]
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.phoneForm.valid) {
      this.commonService.updatePhoneNumber(this.userID, this.phoneForm.value.phoneNumber).subscribe(res => {
        if (res['responseCode'] === 0) {
          this.toastr.success('Phone number updated successfully');
          this.dialogRef.close(true);
        } else {
          this.toastr.error(res['message'], 'Error');
          this.dialogRef.close(true);
        }
      }, error => {
        this.toastr.error(error, 'Error');
        this.dialogRef.close(true);
      });
    } else {
      this.toastr.error('Please enter valid phone number', 'Error');
      this.submitted = false;
    }
  }
}
